import '@babel/polyfill'
import 'airbnb-js-shims'
import React, { Component } from 'react'
import { Provider } from 'react-redux'
import ReactGA from 'react-ga'
import Raven from 'raven-js'
import LogRocket from 'logrocket'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { SnackbarProvider } from 'notistack'
import theme from '../config/theme'
import configureStore from '../redux/configureStore'
import Root from './Root'
import withErrorHandler from '../errors/withErrorHandler'

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('UA-73000050-1') // coresight account
  Raven.config(
    'https://5ad7cbca82d44399ace496f1c17d4615@sentry.io/211929'
  ).install()
  LogRocket.init('ujootb/coresight-react')
} else {
  ReactGA.initialize('UA-111791656-1', { debug: false }) // jth account
  // const { whyDidYouUpdate } = require('why-did-you-update')
  // whyDidYouUpdate(React)
}

ReactGA.pageview(window.location.pathname + window.location.search)

if (window.drift) {
  window.drift.on('startConversation', () =>
    ReactGA.event({ category: 'Drift', action: 'startConversation' })
  )
  window.drift.on('emailCapture', () =>
    ReactGA.event({ category: 'Drift', action: 'emailCapture' })
  )
  window.drift.on('message:sent', () =>
    ReactGA.event({ category: 'Drift', action: 'userSentMessage' })
  )
  window.drift.on('message', () =>
    ReactGA.event({ category: 'Drift', action: 'userReceivedMessage' })
  )
}

const { store, persistor } = configureStore()
const onBeforeLift = () => {}

class App extends Component {
  render () {
    return (
      <Provider store={store}>
        <PersistGate
          persistor={persistor}
          onBeforeLift={onBeforeLift}
          loading={<div>loading</div>}
        >
          <SnackbarProvider
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          >
            <MuiThemeProvider theme={theme}>
              <CssBaseline />
              <Root />
            </MuiThemeProvider>
          </SnackbarProvider>
        </PersistGate>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/containers/App.js